import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllTransportThunk } from 'components/pages/transport-task/thunk/transportTaskThunk';
import { PAGINATION } from 'utils/constants';
import { SCREEN_TYPE } from 'utils/enums';

const _paginateDefault: Pagination = {
    page: 1,
    per_page: PAGINATION.LIMIT_PER_PAGE,
    total: 0,
    total_pages: 0,
};

const initialState: TransportTaskState = {
    screenMode: SCREEN_TYPE.list,
    getKeywords: [],
    formSearch: undefined,
    taskId: '',
    status: -1,
    paginateMetaData: _paginateDefault,
    dataTable: [],
    sort: {
        ascending: true,
        fieldName: 'task_id',
        sortColumn: -1,
    },
    sortDetails: {
        ascending: false,
        fieldName: '',
        sortColumn: -1,
    },
    detailDataTable: [],
    detailPaginateMetaData: _paginateDefault,
};

const reducers = {
    setMode: (state: TransportTaskState, action: PayloadAction<SCREEN_TYPE>) => {
        state.screenMode = action.payload;
    },
    setKeywords: (state: TransportTaskState, action: PayloadAction<string[]>) => {
        state.getKeywords = action.payload;
    },
    setFormSearch: (state: TransportTaskState, action: PayloadAction<ITransportSearch>) => {
        state.formSearch = action.payload;
    },
    setTaskId: (state: TransportTaskState, action: PayloadAction<string>) => {
        state.taskId = action.payload;
    },
    setStatus: (state: TransportTaskState, action: PayloadAction<number>) => {
        state.status = action.payload;
    },
    setPaginateMetaData: (state: TransportTaskState, action: PayloadAction<Pagination>) => {
        state.paginateMetaData = action.payload;
    },
    setDataTable: (state: TransportTaskState, action: PayloadAction<ITransportTaskTable[]>) => {
        state.dataTable = action.payload;
    },
    setDetailDataTable: (state: TransportTaskState, action: PayloadAction<ITaskContainer[]>) => {
        state.detailDataTable = action.payload;
    },
    setDetailPaginateMetaData: (state: TransportTaskState, action: PayloadAction<Pagination>) => {
        state.detailPaginateMetaData = action.payload;
    },
    setSort: (state: TransportTaskState, action: PayloadAction<SortState | undefined>) => {
        state.sort = action.payload;
    },
    setSortDetails: (state: TransportTaskState, action: PayloadAction<SortState | undefined>) => {
        state.sortDetails = action.payload;
    },
    resetTransSportTaskState: () => initialState,
};

export const transportTaskSlice = createSlice({
    name: 'transportTask',
    initialState,
    reducers,
    extraReducers: (builder) => {
        builder.addCase(getAllTransportThunk.fulfilled, (state, action) => {
            state.dataTable = action.payload.data ?? [];
            state.paginateMetaData = action.payload.pagination || _paginateDefault;
        });
    },
});

export const {
    // Detail
    setDetailDataTable,
    setDetailPaginateMetaData,
    // List
    setDataTable,
    setMode,
    setKeywords,
    setFormSearch,
    setTaskId,
    setStatus,
    setPaginateMetaData,
    setSort,
    resetTransSportTaskState,
    setSortDetails,
} = transportTaskSlice.actions;

export default transportTaskSlice.reducer;
